// extracted by mini-css-extract-plugin
export var boldText = "_32-4";
export var checkboxContainer = "_32-6";
export var closeIcon = "_32-g";
export var container = "_32-0";
export var drawer = "_32-8";
export var drawerContent = "_32-9";
export var extraSmallText = "_32-5";
export var fulfillmentGroupTable = "_32-e";
export var largeText = "_32-3";
export var loadingSpinnerContainer = "_32-h";
export var mediumText = "_32-2";
export var narrow = "_32-f";
export var notificationLink = "_32-j";
export var packageCheckIconContainer = "_32-7";
export var slideoutHeaderContainer = "_32-a";
export var slideoutModal = "_32-c";
export var stickyHeaderWrapper = "_32-b";
export var table = "_32-i";
export var tableContainer = "_32-d";
export var tertiaryText = "_32-1";